import IconBell from 'src/icons/IconBell'

import TaskOffsetMenu from './TaskOffsetMenu'

interface ReminderDaysMenuProps {
  defaultReminderInHours: number | undefined
  setDefaultReminderInHours: (hours: number | undefined) => void
}

const ReminderDaysMenu = ({
  defaultReminderInHours,
  setDefaultReminderInHours,
}: ReminderDaysMenuProps) => (
  <TaskOffsetMenu
    value={defaultReminderInHours}
    setValue={setDefaultReminderInHours}
    label="Default reminder"
    testId="reminder-offset-menu-trigger"
    icon={
      <IconBell className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
    }
  />
)

export default ReminderDaysMenu
